import { EAuthRole } from '@qapline/api';
import { config as sharedConfig } from '@qapline/config';
import { env } from 'env';
export const config = {
    ...sharedConfig(env.VITE_MODE),
    allowedRoles: [EAuthRole.Admin, EAuthRole.QaplineEmployee],
    routes: {
        auth: {
            login: '/login',
            signup: '/signup',
            requestResetPassword: '/request-password',
            resetPassword: '/reset-password',
            logout: '/logout',
        },
        dashboard: {
            dashboard: '/dashboard',
            cashflow: '/dashboard/cashflow',
        },
        expense: {
            overview: '/expenses',
            create: '/expenses/new',
            detail: '/expenses/:expenseId',
        },
        commission: {
            overview: '/commissions',
            create: '/commissions/new',
            detail: '/commissions/:commissionId',
            export: '/commissions/export/:commissionId',
        },
        carrier: {
            overview: '/carriers',
            detail: '/carriers/:carrierId',
            create: '/carriers/new',
        },
        customer: {
            overview: '/customers',
            detail: '/customers/:customerId',
            create: '/customers/new',
        },
        invoice: {
            overview: '/invoices',
            detail: '/invoices/:invoiceId',
            create: '/invoices/new',
        },
        offer: {
            overview: '/offers',
            detail: '/offers/:offerId',
            create: '/offers/new',
        },
        dispatcher: {
            detail: '/dispatchers/:dispatcherId',
            create: '/dispatchers/new',
            onboarding: '/dispatchers/onboarding',
        },
        attachment: {
            detail: '/attachments/:attachmentId',
            create: '/attachments/new',
            upload: '/attachments/upload',
        },
    },
    // Paths that used to be served before the attachment routes were pluralised. Upload links
    // handed out to carriers are long lived, so the old paths have to keep working.
    legacyRoutes: {
        attachment: {
            upload: '/attachment/upload',
        },
    },
};
